"use client";

import React, {FC} from "react";
import {AlertCircle, CheckCircle} from "lucide-react";
import {Button} from "@/shared/components/ui/button";

interface ToastProps {
    message: string;
    type?: "success" | "error";
    onClose?: () => void;
    // rozmiar karty – opcjonalnie inny dla modala vs top-level
    className?: string;
}

export const Toast: FC<ToastProps> = ({message, type = "success", onClose, className}) => {
    const isSuccess = type === "success";

    return (
        <div
            className={`bg-white border shadow-lg rounded-md px-4 py-3 flex items-center gap-3 min-w-[240px] ${className ?? ""} ${isSuccess ? "border-green-200" : "border-red-200"}`}>
            {isSuccess ? (
                <CheckCircle className="w-5 h-5 text-green-500"/>
            ) : (
                <AlertCircle className="w-5 h-5 text-red-500"/>
            )}
            <div className={`flex-1 text-sm ${isSuccess ? "text-green-700" : "text-red-700"}`}>{message}</div>
            {onClose && (
                <Button
                    type="button"
                    variant="ghost"
                    size="icon-sm"
                    onClick={onClose}
                    className="p-1 rounded hover:bg-gray-100 hover:scale-105 transition"
                >
                    <span className="w-5 h-5 text-gray-600">×</span>
                </Button>
            )}
        </div>
    );
};

